export enum FormInputType {
  DOCUMENT = 'DOCUMENT',
  FULL_TEXT = 'FULL_TEXT',
  ONLY_LETTERS = 'ONLY_LETTERS',
  ONLY_NUMBERS = 'ONLY_NUMBERS',
  EMAIL = 'EMAIL',
  CUSTOM_MASK = 'CUSTOM_MASK'
}

export enum FormDocumentInputTemplate {
  ALPHANUMERIC = 'ALPHANUMERIC',
  DIGITS = 'DIGITS',
  NIT = 'NIT',
  CNPJ = 'CNPJ',
  CPF = 'CPF',
  CUIL = 'CUIL',
  CUIT = 'CUIT',
  RUC_PE = 'RUC_PE'
}
